import React, { useState } from 'react';
import styled from 'styled-components';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ChangePasswordPage = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState('');

  const handleReset = () => {
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setError('');
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New Password and Confirm Password must match.');
      return;
    }

    setError('');

    try {
      const response = await axios.post('/User/ChangePassword', {
        oldPassword,
        newPassword,
        confirmPassword,
      });

      toast.success(response.data.message || 'Password updated successfully!');
      handleReset(); // Clear form after success
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update password.');
    }
  };

  return (
    <Container>
      <Header>
        <Heading>Change Password</Heading>
      </Header>
      <Card>
        <Form onSubmit={handleUpdate}>
          <Field>
            <Label>
              Old Password<Asterisk>*</Asterisk>
            </Label>
            <PasswordWrapper>
              <Input
                type={showOld ? 'text' : 'password'}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                required
              />
              <ToggleIcon onClick={() => setShowOld(!showOld)}>
                {showOld ? <FiEye /> : <FiEyeOff />}
              </ToggleIcon>
            </PasswordWrapper>
          </Field>

          <Field>
            <Label>
              New Password<Asterisk>*</Asterisk>
            </Label>
            <PasswordWrapper>
              <Input
                type={showNew ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <ToggleIcon onClick={() => setShowNew(!showNew)}>
                {showNew ? <FiEye /> : <FiEyeOff />}
              </ToggleIcon>
            </PasswordWrapper>
          </Field>

          <Field>
            <Label>
              Confirm Password<Asterisk>*</Asterisk>
            </Label>
            <PasswordWrapper>
              <Input
                type={showConfirm ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <ToggleIcon onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? <FiEye /> : <FiEyeOff />}
              </ToggleIcon>
            </PasswordWrapper>
          </Field>

          {error && <ErrorText>{error}</ErrorText>}

          <ButtonGroup>
            <Button type="button" onClick={handleReset} reset>
              Reset
            </Button>
            <Button type="submit">Update</Button>
          </ButtonGroup>
        </Form>
      </Card>
      <ToastContainer />
    </Container>
  );
};

export default ChangePasswordPage;

// Styled Components
const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', Semibold;
  color: #2B3497;
`;

const Card = styled.div`
  background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 27px;
  opacity: 1;
  width: 100%;
  max-width: 500px;
  margin: auto;            // 💡 Centers both vertically and horizontally
  position: relative;      // Needed for margin auto to work in flex

`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', Semibold;
  color: #000000;
  margin-bottom: 5px;
  font-weight: 600;
`;

const Asterisk = styled.span`
  color: red;
`;

const PasswordWrapper = styled.div`
  position: relative;
`;

const Input = styled.input`
  width: 90%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', Regular;
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const ToggleIcon = styled.span`
  position: absolute;
  right: 0;
  top: 8px;
  cursor: pointer;
  color: #2B3497;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: ${(props) => (props.reset ? 'red' : '#3d46b4')};
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  color: white;
  font-size: 14px;
  font-family: 'Segoe UI', Semibold;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => (props.reset ? '#c9302c' : '#1e2a7d')};
  }
`;


const ErrorText = styled.div`
  color: red;
  font-size: 14px;
  font-family: 'Segoe UI', Semibold;
`;

